










 

 





















const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "meetingId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutcomeCard_task",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IntegratedTaskContent_task"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discussionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskEditorDetails",
      "kind": "LinkedField",
      "name": "editors",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "integration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskIntegrationLink_integration"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "meetingId",
          "variableName": "meetingId"
        }
      ],
      "kind": "ScalarField",
      "name": "isHighlighted",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditingStatus_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskFooter_task"
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node ).hash = "cdb73c864bc14469f87abbcc663e385b";

export default node;
